import React from 'react';
import { Page } from 'components';
import 'styles/static_pages.scss';
import classNames from 'lib/classNames';

const FaqScreen = () => (
	<Page
		background="white"
		padding={0}
		header={{
			title: "FAQ's",
		}}
	>
		<div className={classNames('text-gray-700 static_page')}>
			<h4>Simple setup instructions</h4>

			<h6>Setup cart:</h6>
			<p>Visit Settings Page And Setup/Design Your Stores Default Cart.</p>
			<h6>Activate cart:</h6>
			<p>Click Activate at the top of the settings page.</p>
			<p>
				(Note: This will activate the your cart immediately on your storefront and display any upsell campaigns
				you currently have active.)
			</p>
			<h6>Create Upsell Campaigns:</h6>
			<p>Visit Campaign Page To Create Your 1St Upsell Campaign.</p>

			<h4>How to turn monster upsell cart off/on?</h4>
			<p>At the top of the settings page.</p>
			<h4>What happens if Monster Upsells Cart doesn’t load?</h4>
			<p>
				At the top of the settings Your normal cart will be activated and customers will still be able to
				checkout seamlessly.
			</p>
			<h4>Can i run multiple campaigns on the same cart?</h4>
			<p>Multiple campaigns can run on the cart at the same time but only 1 campaign (type) at a time.</p>
			<p>For example: If 2 Add To Unlock campaigns are running only 1 will show.</p>
			<h4>If 2 or more campaign types target the same product which campaign shows?</h4>
			<p>
				Already activated campaigns on storefront will override new types to give the customer best user
				experience.
			</p>
			<h6>
				If no existing campaign type was previously activated the following hierarchy will take place based on
				campaign product targeting:
			</h6>
			<p>Order of least favored to most favored product targeting options. </p>
			<ul className={classNames('list-decimal list-inside')} style={{ marginBottom: 13 }}>
				<li style={{ fontSize: 13 }}>All products</li>
				<li style={{ fontSize: 13 }}>Collection</li>
				<li style={{ fontSize: 13 }}>Single product (most favored targeting)</li>
			</ul>
			<h6>Campaign Types using the same product targeting options:</h6>
			<p>The newest made campaign wins.</p>
			<h4>How do I cancel my subscription?</h4>
			<p>Uninstall the app, it's better to disable the custom cart before uninstalling.</p>
			<h4>Do you make changes to my store code?</h4>
			<p>Yes. We automatically add 2 snippets and 2 files to your theme.</p>
			<p>It’s really easy to remove all Monster Upsell code from your theme</p>
			<ul>
				<li>
					<p>Delete these 2 files from your theme code</p>
					<img src="https://s3-us-west-2.amazonaws.com/apps.static.resources/snippetsNames.png" />
				</li>
				<li>
					<p>and these 2 snippets from your theme.liquid</p>
					<img src="https://s3-us-west-2.amazonaws.com/apps.static.resources/snippetsCalls.png" />
				</li>
			</ul>
			<h4>
				Why are my heat-map/screen recording tools (example: hotjar, crazy egg) not showing the correct shopping
				cart?
			</h4>
			<p>
				We are trying to find a workaround for this, however for now these tools may not import the correct css.
				Rest assured your cart is displayed perfectly for your customers.
			</p>
			<h4>Does it work with dynamic checkout buttons?</h4>
			<p>
				No, it doesn't. You will need to deactivate those buttons if you want checkout to go through monster
				cart.
			</p>
			<h4>When will there be more updates?</h4>
			<p>
				Our goal is to be the only upsell app you will ever need. We have already started working on new updates
				you are going to love and are planning to send updates live monthly! (Feel free to email us feature
				suggestions.)
			</p>
			<p>
				If you have any further questions feel free to contact our team at{' '}
				<a
					href="mailto:support@monsterapps.shop"
					target="_blank"
					className={classNames('text-blue-500 font-bold')}
				>
					support@monsterapps.shop
				</a>
			</p>
		</div>
	</Page>
);

export default FaqScreen;
